import './global.css';

import React from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import store from './store';
import AppRouter from './Router';
import { sentryInit } from './Sentry';
import { unregister } from './registerServiceWorker';

sentryInit();

unregister();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <AppRouter />
  </Provider>,
);
